import { Core } from "@faire/design-tokens";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Typography } from "@faire/web/slate/Typography";
import React from "react";
import { FileUploaderDropzone } from "./FileUploaderDropzone";
import { useFileUploaderState } from "./useFileUploaderState";
export var FileUploader = function FileUploader(props) {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var state = useFileUploaderState(props.onUploadSuccess, props.onUploadError);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FileUploaderDropzone, {
    currentFile: props.currentFile,
    uploadCta: props.uploadCta,
    height: props.height,
    width: props.width,
    maxFileSize: props.maxFileSize,
    accepts: props.accepts,
    strictLocalize: strictLocalize,
    onRemoveFile: props.onRemoveFile,
    onUploadSuccess: state.handleUploadSuccess,
    onUploadError: state.handleUploadError,
    loading: state.loading,
    error: !!state.errorMessage || props.invalidFile,
    showFileIcon: props.showFileIcon
  }), /*#__PURE__*/React.createElement(ErrorMessage, {
    error: state.errorMessage
  }));
};
var ErrorMessage = function ErrorMessage(_ref) {
  var error = _ref.error;
  if (!error) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Typography, {
    color: Core.text.critical,
    variant: "labelSansRegular",
    style: {
      marginTop: 3
    }
  }, error);
};